// removed by extract-text-webpack-plugin
module.exports = {"container":"_2_6qnGaXPJ_Am0QuDv2xuL","photoContainer":"_1ZZb3lMqADuOIE51B8X4AC","changeLabel":"_11ilkSLjekTBByAe_0oSkV","photo":"_2gomixCbpr3og8WpHcmH0l","avatar":"_2qIYNjZHIToG9q7XhQy2bs","fileInput":"WtTqTHPZGe2YPUUqEpcha","info":"_4wkvLYRL11RQSS5PG7Zri","fioContainer":"_3GFPwuR7JL_wNov85XaFMi","name":"_3WGi5WP9ZeL29EIWmJDva-","email":"_1JpNWHrmDF8MRRzhd8HALK","company":"_3Arry1QE8hxoXFUE_TqXDN","controls":"_1gmXXsaKa3fJRRX_3e6UW-","editBtn":"_3OoXx5LsziroprafR_w2Zx"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupPage/GroupInfo/GroupInfo.pcss
// module id = 1375
// module chunks = 0